export const unwrap = (response) => response.data?.data ?? response.data

export const sortAsc = (field = 'name') => (data) => {
  if (!Array.isArray(data)) return data

  return [...data].sort((left, right) => {
    const a = (left[field] ?? left.name ?? '').toString()
    const b = (right[field] ?? right.name ?? '').toString()
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
  })
}

export const byName = sortAsc('name')
export const byTitle = sortAsc('title')

const CLASS_ORDER = ['nursery', 'lkg', 'ukg']

const classRank = (name = '') => {
  const lower = name.trim().toLowerCase()
  const specialIdx = CLASS_ORDER.indexOf(lower)
  if (specialIdx !== -1) return specialIdx
  const num = parseInt(lower.replace(/^class\s*/i, ''), 10)
  return isNaN(num) ? 999 : CLASS_ORDER.length + num
}

export const sortClasses = (data) => {
  if (!Array.isArray(data)) return data
  return [...data].sort((a, b) => {
    const rankDiff = classRank(a.name) - classRank(b.name)
    if (rankDiff !== 0) return rankDiff
    return (a.section || '').localeCompare(b.section || '', undefined, { numeric: true, sensitivity: 'base' })
  })
}

export const toArray = (data, keys = []) => {
  if (Array.isArray(data)) return data

  for (const key of keys) {
    if (Array.isArray(data?.[key])) return data[key]
  }

  return []
}
